import react from "react";

function Loader():JSX.Element {
    return (
        <img className="loaderImg" style={{ width: "200px" }} src="../assets/images/pageLoader.gif" />
    )
}
export default Loader;